(() => {
  function ga4Event(name, link) {
    const params = {
      event_category: 'local_intent',
      link_url: link.getAttribute('href') || '',
      link_text: (link.textContent || '').trim().slice(0, 100),
      page_location: window.location.href,
      transport_type: 'beacon',
    };

    if (typeof window.gtag === 'function') {
      window.gtag('event', name, params);
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...params });
  }

  function emailLinkId(link) {
    if (link.getAttribute('id') === 'powhatan-email-bottom') {
      return 'powhatan-email-bottom';
    }

    const emailLinks = [...document.querySelectorAll('a[href]')]
      .filter((item) => /^mailto:/i.test(item.getAttribute('href') || ''));
    const index = emailLinks.indexOf(link);

    return index < 0 ? 'email-link' : `email-link-${index + 1}`;
  }

  function emailClick(link) {
    if (typeof window.gtag !== 'function') return;

    window.gtag('event', 'email_click', {
      event_category: 'local_intent',
      link_id: emailLinkId(link),
      page_path: window.location.pathname,
      transport_type: 'beacon',
    });
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link) return;

    const href = link.getAttribute('href') || '';
    if (/^tel:/i.test(href)) {
      ga4Event('click_to_call', link);
      return;
    }

    if (/^mailto:/i.test(href)) {
      emailClick(link);
      return;
    }

    if (/^https?:\/\/(?:www\.)?(?:maps\.app\.goo\.gl|google\.[^/]+\/maps|maps\.google\.[^/]+)/i.test(href)) {
      ga4Event('directions_click', link);
    }
  }, { passive: true });
})();
